import { SUPPORTED_LOCALES } from '../i18n/config';

const WEEK_START_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Public Arena URL for the active UI locale (`/gaisuke` for ja, `/en/gaisuke` for en, …). */
export function gaisukePublicPath(locale: string): string {
  if (locale === 'ja' || locale.startsWith('ja-')) return '/gaisuke';
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) return `/${locale}/gaisuke`;
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) return `/${short}/gaisuke`;
  return '/gaisuke';
}

/** 週次サマリー共有 URL（ログイン不要） */
export function gaisukeWeeklySummaryPath(weekStart: string, locale: string): string {
  const base = gaisukePublicPath(locale).replace(/\/$/, '');
  return `${base}/weekly/${weekStart}`;
}

/** Arena FAQ（ログイン不要） */
export function gaisukeFaqPath(locale: string): string {
  const base = gaisukePublicPath(locale).replace(/\/$/, '');
  return `${base}/faq`;
}

export function isGaisukeFaqPath(pathname: string): boolean {
  if (pathname === '/gaisuke/faq' || pathname === '/gaisuke/faq/') return true;
  return SUPPORTED_LOCALES.some(
    (loc) => pathname === `/${loc}/gaisuke/faq` || pathname === `/${loc}/gaisuke/faq/`
  );
}

export function isValidGaisukeWeekStart(weekStart: string): boolean {
  return WEEK_START_RE.test(weekStart);
}

export function isGaisukePublicPath(pathname: string): boolean {
  if (pathname === '/gaisuke/settings' || pathname.startsWith('/gaisuke/settings/')) {
    return false;
  }
  if (pathname === '/gaisuke' || pathname.startsWith('/gaisuke/')) return true;
  return SUPPORTED_LOCALES.some(
    (loc) =>
      pathname === `/${loc}/gaisuke` || pathname.startsWith(`/${loc}/gaisuke/`)
  );
}

